import React from 'react';
import { t } from '@citrite/translate';
import {
	DiagnosticsIcon,
	layout,
	NotificationBadgeIcon,
	palette,
} from '@citrite/web-ui-component';
import styled from '@emotion/styled';
import { GenericErrorBoundary } from 'App/GenericErrorBoundary';
import { FlyoverWrapper } from 'App/Header/FlyoverWrapper';
import { useServiceContinuityContext } from 'App/ServiceContinuity';
import { ServiceContinuityManager } from '../ServiceContinuity/ServiceContinuityManager';

const StyledNotificationBadgeIcon = styled(NotificationBadgeIcon)`
	position: absolute;
	right: 0;
	padding-right: 10px;
	padding-top: ${layout.tinySpace};
`;

const componentId = 'offline-availability';

const _ClientDiagnosticsLauncher: React.FC = () => {
	const { shieldStatus } = useServiceContinuityContext();
	const hasExpiredOrExpiringLeases =
		shieldStatus?.expiredLeases?.length > 0 || shieldStatus?.expiringLeases?.length > 0;
	const hasActiveLeases = shieldStatus?.activeLeases?.length > 0;
	const shouldEnableDiagnosticsLauncher = hasExpiredOrExpiringLeases || hasActiveLeases;

	return shouldEnableDiagnosticsLauncher ? (
		<FlyoverWrapper
			flyoverContent={<ServiceContinuityManager />}
			icon={DiagnosticsIcon}
			title={t('Workspace:service_continuity.offline_availability_title')}
			ariaLabel={t('Workspace:service_continuity.offline_availability_title')}
			dataTestId={componentId}
			id={componentId}
			closeOnFlyoverClick
			iconSize={25}
			notificationIcon={
				hasExpiredOrExpiringLeases ? (
					<StyledNotificationBadgeIcon color={palette.red900} size={12} />
				) : undefined
			}
		/>
	) : null;
};

export const ClientDiagnosticsLauncher = () => (
	<GenericErrorBoundary
		renderProp={() => <_ClientDiagnosticsLauncher />}
		name="ClientDiagnosticsLauncher"
	/>
);
